import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services';
import { GetNotificationDefParams, GetNotificationDefsParams, GetNotificationDefsResponse, GetNotificationParams, GetNotificationResponse } from 'src/app/core/proto/pigeon/notifications/dtos';
import { NotificationDef } from 'src/app/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private _apiService: ApiService) { }

  getNotifications(
    getNotificationParams: GetNotificationParams,
  ): Observable<GetNotificationResponse> {
    const params: HttpParams = this._apiService.queryParams(
      getNotificationParams,
    );
    return this._apiService.get('/v2-internal/notifications', params);
  }

  getNotificationDefs(
    getNotificationDefsParams: GetNotificationDefsParams,
  ): Observable<GetNotificationDefsResponse> {
    const params: HttpParams = this._apiService.queryParams(
      getNotificationDefsParams,
    );
    return this._apiService.get('/v1/notificationdefs', params);
  }

  getNotificationDef(
    getNotificationDefParams: GetNotificationDefParams,
  ): Observable<NotificationDef> {
    const params: HttpParams = this._apiService.queryParams(
      getNotificationDefParams,
    );

    if (getNotificationDefParams.transportType && getNotificationDefParams.locale) {
      return this._apiService.get(
        `/v1/notificationdef/${getNotificationDefParams.notificationDefUuid}/transport-type/${getNotificationDefParams.transportType}/locale/${getNotificationDefParams.locale}`,
        params,
      );
    } else if (getNotificationDefParams.transportType) {
      return this._apiService.get(
        `/v1/notificationdef/${getNotificationDefParams.notificationDefUuid}/transport-type/${getNotificationDefParams.transportType}`,
        params,
      );
    }

    return this._apiService.get(
      `/v1/notificationdef/${getNotificationDefParams.notificationDefUuid}/locale/${getNotificationDefParams.locale}`,
      params,
    );
  }

  updateNotificationDef(
    notificationDef: NotificationDef,
  ): Observable<NotificationDef> {
    return this._apiService.put('/v1/notificationdef', notificationDef);
  }
}
